/**
 * Configurazione centralizzata dell'applicazione
 */

// Backend API URL - usa variabile d'ambiente o fallback a localhost per sviluppo
// In produzione: impostare VITE_API_URL all'URL del backend pigna-studio (es. https://flow.oystar.ai)
// altrimenti il frontend chiama lo stesso host (es. studio.oystar.ai/api/...) e si ottiene 404 se il host serve solo static.
export const API_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.MODE === 'production' ? '' : 'http://localhost:8001');

// OYSTAR RAG Server URL - istanza dedicata per Studio (porta 8002)
// In produzione può puntare a un server RAG dedicato
export const OYSTAR_RAG_URL = import.meta.env.VITE_OYSTAR_RAG_URL || 'http://localhost:8002';

// Path per chat streaming: default /api/ask/stream (RAG backend). Per oystar.ai/rag con fonti Epis. N usare flow: /api/flow/kb/ask/stream
export const RAG_ASK_STREAM_PATH = import.meta.env.VITE_RAG_ASK_STREAM_PATH || '/api/ask/stream';

// Feature flag: nuovo editor flow (packages/flow-*). Off di default.
// Abilitare con VITE_FLOW_NEXT=true (es. nel .env o variabile d'ambiente Vite).
export const FLOW_NEXT_ENABLED = import.meta.env.VITE_FLOW_NEXT === 'true';

// Versione applicazione - incrementare ad ogni commit importante
export const VERSION = 'v1.417';

console.log('🔧 API_URL configured:', API_URL);
console.log('🔍 OYSTAR_RAG_URL configured:', OYSTAR_RAG_URL);
console.log(`🚀 OYSTAR Studio ${VERSION} - Build:`, new Date().toISOString());

